import React, { useState, useEffect } from 'react';
import './WorkOrderManagement.css';

const WorkOrderManagement = () => {
  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [formData, setFormData] = useState({
    vehicleInfo: {
      plate: '',
      km: '',
      insuranceDate: '',
      inspectionDate: '',
      preInspection: ''
    },
    problem: '',
    services: [],
    parts: [],
    status: 'open',
    customerName: '',
    customerPhone: '',
    estimatedCost: 0
  });

  useEffect(() => {
    loadWorkOrders();
  }, []);

  const loadWorkOrders = async () => {
    setTimeout(() => {
      const mockOrders = [
        {
          id: 1,
          orderNumber: 'WO-2025-001',
          customerName: 'Ahmet Yılmaz',
          customerPhone: '0555 123 4567',
          vehicleInfo: {
            plate: '34 ABC 123',
            km: '125000',
            insuranceDate: '2025-12-31',
            inspectionDate: '2025-06-30',
            preInspection: 'Ön ekspertiz yapıldı'
          },
          problem: 'Motor sesi geliyor, yağ kaçağı var',
          services: ['Motor yağı değişimi', 'Filtre değişimi'],
          parts: ['Motor yağı', 'Yağ filtresi'],
          status: 'in_progress',
          estimatedCost: 1500,
          createdAt: '2025-08-06 09:00',
          technician: 'Mehmet Usta'
        }
      ];
      setWorkOrders(mockOrders);
      setLoading(false);
    }, 1000);
  };

  const handleAddOrder = () => {
    setEditingOrder(null);
    setFormData({
      vehicleInfo: { plate: '', km: '', insuranceDate: '', inspectionDate: '', preInspection: '' },
      problem: '',
      services: [],
      parts: [],
      status: 'open',
      customerName: '',
      customerPhone: '',
      estimatedCost: 0
    });
    setShowAddModal(true);
  };

  const handleSaveOrder = () => {
    if (editingOrder) {
      setWorkOrders(workOrders.map(order => 
        order.id === editingOrder.id 
          ? { ...order, ...formData }
          : order
      ));
    } else {
      const newOrder = {
        id: Date.now(),
        orderNumber: `WO-2025-${String(workOrders.length + 1).padStart(3, '0')}`,
        ...formData,
        createdAt: new Date().toLocaleString(),
        technician: 'Atanacak'
      };
      setWorkOrders([...workOrders, newOrder]);
    }
    setShowAddModal(false);
  };

  const getStatusDisplay = (status) => {
    const statusMap = {
      'open': { text: 'Açık', class: 'open' },
      'in_progress': { text: 'İşlemde', class: 'in-progress' },
      'completed': { text: 'Tamamlandı', class: 'completed' },
      'cancelled': { text: 'İptal', class: 'cancelled' }
    };
    return statusMap[status] || { text: status, class: 'unknown' };
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>İş emirleri yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="work-order-management">
      <div className="page-header">
        <h2>İş Emri Yönetimi</h2>
        <p>Araç servis işlemlerini takip edin</p>
      </div>

      <div className="actions-bar">
        <button className="btn btn-primary" onClick={handleAddOrder}>
          ➕ Yeni İş Emri
        </button>
        <button className="btn btn-success" onClick={loadWorkOrders}>
          🔄 Yenile
        </button>
      </div>

      <div className="work-orders-grid">
        {workOrders.map((order) => (
          <div key={order.id} className="work-order-card">
            <div className="order-header">
              <h3>{order.orderNumber}</h3>
              <span className={`status-badge ${getStatusDisplay(order.status).class}`}>
                {getStatusDisplay(order.status).text}
              </span>
            </div>

            <div className="customer-info">
              <h4>Müşteri Bilgileri</h4>
              <div className="info-row">
                <span className="label">Müşteri:</span>
                <span className="value">{order.customerName}</span>
              </div>
              <div className="info-row">
                <span className="label">Telefon:</span>
                <span className="value">{order.customerPhone}</span>
              </div>
            </div>

            <div className="vehicle-info">
              <h4>Araç Bilgileri</h4>
              <div className="info-row">
                <span className="label">Plaka:</span>
                <span className="value">{order.vehicleInfo.plate}</span>
              </div>
              <div className="info-row">
                <span className="label">KM:</span>
                <span className="value">{order.vehicleInfo.km}</span>
              </div>
              <div className="info-row">
                <span className="label">Sigorta:</span>
                <span className="value">{order.vehicleInfo.insuranceDate}</span>
              </div>
              <div className="info-row">
                <span className="label">Muayene:</span>
                <span className="value">{order.vehicleInfo.inspectionDate}</span>
              </div>
            </div>

            <div className="problem-info">
              <h4>Problem</h4>
              <p>{order.problem}</p>
            </div>

            {order.services.length > 0 && (
              <div className="services-section">
                <h4>Yapılacak İşlemler</h4>
                <div className="services-list">
                  {order.services.map((service, index) => (
                    <span key={index} className="service-tag">{service}</span>
                  ))}
                </div>
              </div>
            )}

            {order.parts.length > 0 && (
              <div className="parts-section">
                <h4>Kullanılacak Parçalar</h4>
                <div className="parts-list">
                  {order.parts.map((part, index) => (
                    <span key={index} className="part-tag">{part}</span>
                  ))}
                </div>
              </div>
            )}

            <div className="order-footer">
              <div className="cost-info">
                <span className="label">Tahmini Maliyet:</span>
                <span className="value">₺{order.estimatedCost}</span>
              </div>
              <div className="order-actions">
                <button className="btn btn-primary btn-sm">
                  ✏️ Düzenle
                </button>
                <button className="btn btn-success btn-sm">
                  ✅ Tamamla
                </button>
                <button className="btn btn-warning btn-sm">
                  🧾 Faturaya Çevir
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Add/Edit Work Order Modal */}
      {showAddModal && (
        <div className="modal">
          <div className="modal-content large">
            <div className="modal-header">
              <h3>{editingOrder ? 'İş Emri Düzenle' : 'Yeni İş Emri'}</h3>
              <button className="close-btn" onClick={() => setShowAddModal(false)}>✕</button>
            </div>
            
            <form onSubmit={(e) => { e.preventDefault(); handleSaveOrder(); }}>
              <div className="form-row">
                <div className="form-group">
                  <label>Müşteri Adı</label>
                  <input
                    type="text"
                    value={formData.customerName}
                    onChange={(e) => setFormData({...formData, customerName: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Telefon</label>
                  <input
                    type="tel"
                    value={formData.customerPhone}
                    onChange={(e) => setFormData({...formData, customerPhone: e.target.value})}
                    required
                  />
                </div>
              </div>

              <div className="vehicle-section">
                <h4>Araç Bilgileri</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Plaka</label>
                    <input
                      type="text"
                      value={formData.vehicleInfo.plate}
                      onChange={(e) => setFormData({
                        ...formData,
                        vehicleInfo: {...formData.vehicleInfo, plate: e.target.value}
                      })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>KM</label>
                    <input
                      type="number"
                      value={formData.vehicleInfo.km}
                      onChange={(e) => setFormData({
                        ...formData,
                        vehicleInfo: {...formData.vehicleInfo, km: e.target.value}
                      })}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Sigorta Tarihi</label>
                    <input
                      type="date"
                      value={formData.vehicleInfo.insuranceDate}
                      onChange={(e) => setFormData({
                        ...formData,
                        vehicleInfo: {...formData.vehicleInfo, insuranceDate: e.target.value}
                      })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Muayene Tarihi</label>
                    <input
                      type="date"
                      value={formData.vehicleInfo.inspectionDate}
                      onChange={(e) => setFormData({
                        ...formData,
                        vehicleInfo: {...formData.vehicleInfo, inspectionDate: e.target.value}
                      })}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Ön Ekspertiz</label>
                  <textarea
                    value={formData.vehicleInfo.preInspection}
                    onChange={(e) => setFormData({
                      ...formData,
                      vehicleInfo: {...formData.vehicleInfo, preInspection: e.target.value}
                    })}
                    rows="3"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Problem Açıklaması</label>
                <textarea
                  value={formData.problem}
                  onChange={(e) => setFormData({...formData, problem: e.target.value})}
                  rows="4"
                  required
                />
              </div>

              <div className="form-group">
                <label>Tahmini Maliyet</label>
                <input
                  type="number"
                  value={formData.estimatedCost}
                  onChange={(e) => setFormData({...formData, estimatedCost: parseFloat(e.target.value)})}
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>
                  İptal
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingOrder ? 'Güncelle' : 'Kaydet'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkOrderManagement; 